import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import useCompanies from '@/modules/Company.js'

const dropdown_companies = ref([])
const dropdown_company_filters = ref({
  name: '',
})
const loading = ref(false)

let lastPage = -1
let filterTimer = null
let refilterPending = false

export default function useCompaniesDropdown(perPage = 10) {
  const store = useStore()
  const userCompanies = store.getters['authenticated_user'].companies
  const userProfile = store.getters['authenticated_user'].user_profile
  const userProfileName = (userProfile && !Array.isArray(userProfile) ? userProfile.name : null) ?? 'Admin'
  const allCompaniesAllowedUserProfiles = ['Admin', 'Engenheiro', 'Técnico']
 

  const { companies, listCompanies, company_filters } = useCompanies()

  const loadNextCompaniesPage = () => {
    const page = currentPage() + 1

    if (page === lastPage) return

    loading.value = true

    listCompanies(currentPage() + 1, perPage).then(() => {
      const companiesNotLoaded = [...companies.value]

      const companiesList = [...dropdown_companies.value, ...companiesNotLoaded]

      if (allCompaniesAllowedUserProfiles.includes(userProfileName)) {
        dropdown_companies.value = companiesList
      } else {
        const companiesListFiltered = companiesList.filter((company) => {
          return userCompanies.some((userCompany) => {
            return userCompany.id === company.id
          })
        })

        dropdown_companies.value = companiesListFiltered
      }

      lastPage = page
    }).catch(() => {
      // falha de rede: nao deixa o dropdown travado em "carregando"
    }).finally(() => {
      loading.value = false

      // o usuario digitou enquanto a busca anterior ainda estava em andamento:
      // refaz a busca com o texto final (antes esse filtro era descartado)
      if (refilterPending) {
        refilterPending = false
        updateFilters()
      }
    })
  }

  const currentPage = () => {
    return Math.floor(dropdown_companies.value.length / perPage)
  }

  const onCompaniesDropdownScroll = (e) => {
    if (
      e.srcElement.offsetHeight + e.srcElement.scrollTop >=
      e.srcElement.scrollHeight
    ) {
      if (!loading.value) {
        loadNextCompaniesPage()
      }
    }
  }

  const updateFilters = () => {
    if (loading.value) {
      refilterPending = true
      return
    }

    company_filters.value = dropdown_company_filters.value
    dropdown_companies.value = []
    lastPage = -1

    loadNextCompaniesPage()
  }

  watch(dropdown_company_filters.value, () => {
    clearTimeout(filterTimer)
    filterTimer = setTimeout(updateFilters, 250)
  })

  return {
    dropdown_companies: computed(() => dropdown_companies.value),
    dropdown_company_filters: computed(() => dropdown_company_filters.value),
    loadNextCompaniesPage,
    onCompaniesDropdownScroll,
  }
}
